import { createApp } from "vue";
import App from "./App.vue";
import VueLazyload from "vue-lazyload";

import "vue-advanced-cropper/dist/style.css";
/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";

import pinia from "./pinia/pinia.js";
import piniaPersist from "pinia-plugin-persist";
import mitt from "mitt";

import "@/core/plugins/prismjs";
import "bootstrap";

const emitter = mitt();
const app = createApp(App);

app.use(store);
app.use(router);
app.use(ElementPlus);
pinia.use(piniaPersist);
app.use(pinia);
app.use(VueLazyload);
app.config.globalProperties.emitter = emitter;

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);

app.use(i18n);

app.mount("#app");
